import React, { useState } from "react";
import { Autocomplete, Grid } from "@mui/material";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { useMaterialUIController, setCurrentDialog } from "context";
import { addNewTranslationDO } from "utils/translateUtils";
import { T } from "components/alove/Translator";
import MDButton from "components/MDButton";
import { Position } from "models/content/Position";
import { Translation } from "models/content/Translation";

const MDInput = require("components/MDInput/index.js").default;

interface AddNewTranslationModalProps {
  positionsDropdownRender: (onChange, s?) => JSX.Element;
  refresh: () => void;
}

export const AddNewTranslationModal: React.FC<AddNewTranslationModalProps> = ({
  positionsDropdownRender,
  refresh,
}) => {
  const [newTranslation, setNewTranslation] = useState({} as Partial<Translation>);

  const handleConfirm = async () => {
    await addNewTranslationDO(newTranslation);
    refresh();
    setNewTranslation({} as Partial<Translation>);
  };

  return (
    <AloveDialog
      dialogType={DialogType.AddNewTranslation}
      dialogTitle="Add New Translation"
      dialogConfirm="Add"
      handleConfirm={handleConfirm}
      valid={!!newTranslation.entityId && !!newTranslation.txt && !!newTranslation.position}
    >
      <MDInput
        label="Syntax"
        value={newTranslation.entityId}
        onChange={(e) => setNewTranslation({ ...newTranslation, entityId: e.target.value })}
      />
      <MDInput
        label="Translation"
        value={newTranslation.txt}
        onChange={(e) => setNewTranslation({ ...newTranslation, txt: e.target.value })}
      />
      {positionsDropdownRender((v:Position) => setNewTranslation({ ...newTranslation, position: [v.id] }))}
    </AloveDialog>
  );
};
